import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { resetNotification } from "../../store/notificationSlice";
import theme from "../../theme";

export default function Notification() {
  const dispatch = useDispatch();
  const notification = useSelector((state: RootState) => state.notification);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(resetNotification());
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={notification.show}
      autoHideDuration={4000}
      onClose={handleClose}
      message={notification.message}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        sx={{
          width: "100%",
          "&": {
            boxShadow:
              "rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;",
          },
          "&.MuiAlert-standardSuccess": {
            // background: theme.palette.primary.main,
            background: "#2e7d32",
          },
          "&.MuiAlert-standardSuccess .MuiAlert-icon, &.MuiAlert-standardSuccess .MuiAlert-message, &.MuiAlert-standardSuccess .MuiAlert-action":
            {
              color: "#fff",
            },
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
